/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeTableCategory } from "../../d-table-category";
import { DThemeWhiteTableHeader } from "./d-theme-white-table-header";

export class DThemeWhiteTableCategory
	extends DThemeWhiteTableHeader
	implements DThemeTableCategory {}
